import * as React from 'react';
import { PublishButtonContainer } from '../PublishButton';
import { SaveDraftButtonContainer } from '../SaveDraftButton';
import * as styles from './HiddenBase.desktop.css';

export const HiddenBaseDesktop = () => {
  return (
    <div className={styles['wrapper']}>
      <PublishButtonContainer />

      <div className={styles['draft_button']}>
        <SaveDraftButtonContainer />
      </div>
    </div>
  );
};
